<template>
  <div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'NotFound',
  mounted () {
    $(document).scrollTop(0);
  },
  beforeCreate: function() {
      document.body.className = 'not_found';
      $('.loader_wrapper').css('display','flex');
  }
}
</script>
